import React from 'react';
import Flex from '@cobalt/react-flex';
import Icon from '@cobalt/react-icon';
import { Text } from '@cobalt/react-typography';

const LabeledIcon = ({
  forwardedRef,
  label,
  iconName,
  iconColor,
  iconSize,
  labelColor,
  labelSize,
  labelWeight
}) => {
  return /*#__PURE__*/React.createElement(Flex, {
    forwardedRef: forwardedRef,
    alignY: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    paddingRight: "1"
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor,
    size: iconSize,
    name: iconName
  })), /*#__PURE__*/React.createElement(Text, {
    inline: true,
    color: labelColor,
    size: labelSize,
    weight: labelWeight
  }, label));
};

export default LabeledIcon;
